const useRegExpFormatter = (regExp) => {
  const formattedRegExp = regExp.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');

  return { formattedRegExp };
};

export { useRegExpFormatter };
